import { useState, useCallback } from 'react'
import customAxios from 'routes/Pages/util/Api'
import authHeader from 'services/auth/jwt/auth-header'

let cachePromise = null

const loadProducts = () => {
    if (!cachePromise) {
        cachePromise = customAxios
            .get('/Ops/GetProducts', { headers: authHeader() })
            .then(({ data }) =>
                (data ?? []).map((item) => ({
                    value: item.productName,
                    label: item.productName,
                }))
            )
            .catch((err) => {
                cachePromise = null // allow retry after a failure
                throw err
            })
    }
    return cachePromise
}

export function useGetProducts() {
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const fetchProducts = useCallback(async () => {
        setIsLoading(true)
        try {
            setProducts(await loadProducts())
        } finally {
            setIsLoading(false)
        }
    }, [])

    return { products, isLoading, fetchProducts }
}